module.exports = __webpack_public_path__ + "static/media/gu.ab04d606.ogg";